<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-panel header="{{ 'GARANTIASIDONEAS.LBL_INFOGARANTIASIDONEAS' | translate}}" *ngIf="garantiasIdoneas">

        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_CODIGO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "> <strong>{{garantiasIdoneas.codigo}} </strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_FONDO' | translate }}:</label>
          <label  class="lg:col-3 col-6 md:col-8 "> <strong>{{garantiasIdoneas.fondoGarantia}} </strong></label>

        </div>

        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_CODIGOSHIVAM' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "> <strong>{{garantiasIdoneas.codigoShivam}} </strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_NOMBRE' | translate }}:</label>
          <label  class="lg:col-3 col-6 md:col-8 "> <strong>{{garantiasIdoneas.nombre}} </strong></label>
        </div>


        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_MONTOMINIMO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "> <strong>{{garantiasIdoneas.montoMinimo}} </strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_MONTOMAXIMO' | translate }}:</label>
          <label  class="lg:col-3 col-6 md:col-8 "> <strong>{{garantiasIdoneas.montoMaximo}} </strong></label>
        </div>

        <div class="grid">
          <label class="lg:col-3 col-3 md:col-4 control-label" >{{ 'GARANTIASIDONEAS.LBL_DESCRIPCION' | translate }}:</label>
          <label class="lg:col-9 col-9 md:col-8 "><strong>{{garantiasIdoneas.descripcion}}</strong></label>
        </div>

        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_PERIODOGRACIA' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.indicadorPeriodoGracia ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_MUNICIPIO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.indicadorMunicipio ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>

        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_ANTICIPADO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.indicadorAnticipado ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_ANTICIPADOANUAL' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.indicadorAnticipadoAnual ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>

        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_DIFERIDO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.indicadorDiferido ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>

        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_IVA' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.indicadorIva ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label" *ngIf="garantiasIdoneas.indicadorIva">{{ 'GARANTIASIDONEAS.LBL_IVAPORCENTAJE' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 " *ngIf="garantiasIdoneas.indicadorIva"><strong>{{garantiasIdoneas.iva }}</strong></label>
        </div>

        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_RUT' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.indicadorRut ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_ACTIVIDADES' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.indicadorActividades ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>

        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_CLIENTENUEVO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.indicadorClienteNuevo ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_CLIENTERENOVADO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.indicadorClienteRenovado ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>

        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_TASA' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.indicadorTasa ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label" *ngIf="garantiasIdoneas.indicadorTasa">{{ 'GARANTIASIDONEAS.LBL_TASAPORCENTAJE' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 " *ngIf="garantiasIdoneas.indicadorTasa"><strong>{{garantiasIdoneas.tasaCobro }}</strong></label>
        </div>

        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_DESTINO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.indicadorDestino ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_PLANPAGO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.indicadorPlanPagos ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>

        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_CREDITOCREZCAMOS' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.indicadorRecogerCrezcamos ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>

        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_PLAZOMINIMOMESES' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.plazoMinimo}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_PLAZOMAXIMOMESES' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.plazoMaximo}}</strong></label>
        </div>

        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_PORCENTAJERESPALDO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.porcentajeRespaldo}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_COBROPERFIL' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.indicadorCobroPerfil ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>

        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_NOTIFICACIONFGA' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.indicadorNotificacionFGA ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'GARANTIASIDONEAS.LBL_GARANTIAIDONEA' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{garantiasIdoneas.indicadorGarantiaIdonea ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>

      </p-panel>

      <p-panel header="{{ 'GARANTIASIDONEAS.LBL_DESTINO' | translate}}"
               *ngIf="garantiasIdoneas && garantiasIdoneas.indicadorDestino">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="columnasDestino"
                     [value]="listGarantiasIdoneasDestino"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td class="table-break">{{row.codigoDestinoProducto}}</td>
                  <td class="table-break">{{row.destinoProducto}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>

      <p-panel header="{{ 'GARANTIASIDONEAS.LBL_MUNICIPIO' | translate}}"
               *ngIf="garantiasIdoneas && garantiasIdoneas.indicadorMunicipio">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="columnasMunicipio"
                     [value]="listGarantiasIdoneasMunicipio"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td class="table-break">{{row.departamento}}</td>
                  <td class="table-break">{{row.municipio}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>

      <p-panel header="{{ 'GARANTIASIDONEAS.LBL_ACTIVIDADES' | translate}}"
               *ngIf="garantiasIdoneas && garantiasIdoneas.indicadorActividades">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="columnasActividades"
                     [value]="listaGarantiasIdoneasActividades" selectionMode="single" dataKey="idConstante"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                      [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.actividadEconomica}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>

      <p-panel header="{{ 'GARANTIASIDONEAS.LBL_PRODUCTO' | translate}}"
               *ngIf="garantiasIdoneas">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">

            <p-table [columns]="columnasProducto"
                     [value]="listGarantiasIdoneasProducto"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td class="table-break">{{row.codigoProducto}}</td>
                  <td class="table-break">{{row.producto}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>

      <p-panel header="{{ 'GARANTIASIDONEAS.LBL_TIPOPRODUCTOR' | translate}}"
               *ngIf="garantiasIdoneas">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">

            <p-table [columns]="columnasTiposProductores"
                     [value]="listGarantiasIdoneasTiposProductores"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td class="table-break">{{row.codigoTipoProductor}}</td>
                  <td class="table-break">{{row.tipoProductor}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>

      <p-panel header="{{ 'GARANTIASIDONEAS.LBL_PERIODOGRACIA' | translate}}"
               *ngIf="garantiasIdoneas && garantiasIdoneas.indicadorPeriodoGracia && periodoGracia">

        <div class="grid form-group">
          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <p-checkbox label="{{ 'GARANTIASIDONEAS.LBL_OPCIONAL' | translate}}" binary="true"
                          id="indicadorOpcional"
                          name="nomIndicadorOpcional"
                          [ngModel]="periodoGracia.indicadorOpcional"
                          [disabled]="true"></p-checkbox>
             </div>
          </div>
          <div class="col-12 md:col-3 lg:col-3" >
            <div class="div-form">
              <label>* {{ 'GARANTIASIDONEAS.LBL_PERIODOMINIMO' | translate }}</label>
              <label class="falso-combo-texto">{{periodoGracia.periodoMinimo}}</label>
            </div>
          </div>

          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <label>* {{ 'GARANTIASIDONEAS.LBL_PERIODOMAXIMO' | translate }}</label>
              <label class="falso-combo-texto">{{periodoGracia.periodoMaximo}}</label>
            </div>
          </div>

          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <label>{{'GARANTIASIDONEAS.LBL_PERIODOGRACIA' | translate}}</label>
              <label class="falso-combo-texto">{{periodoGracia.tipoPeriodoGracia}}</label>
            </div>
          </div>

          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <p-checkbox label="{{ 'GARANTIASIDONEAS.LBL_PERIODOINTERESES' | translate}}" binary="true"
                          id="indicadorIntereses"
                          name="nomIndicadorIntereses"
                          [ngModel]="periodoGracia.indicadorIntereses"
                          [disabled]="true"></p-checkbox>
            </div>
          </div>

          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <p-checkbox label="{{ 'GARANTIASIDONEAS.LBL_PERIODOCAPITAL' | translate}}" binary="true"
                          id="indicadorCapital"
                          name="nomIndicadorCapital"
                          [ngModel]="periodoGracia.indicadorCapital"
                          [disabled]="true"></p-checkbox>
             </div>
          </div>

          <div class="col-12 md:col-3 lg:col-3">
            <div class="div-form">
              <p-checkbox label="{{ 'GARANTIASIDONEAS.LBL_PERIODOOTROSCONCEPTOS' | translate}}" binary="true"
                          id="indicadorOtrosConceptos"
                          name="nomIndicadorOtrosConceptos"
                          [ngModel]="periodoGracia.indicadorOtrosConceptos"
                          [disabled]="true"></p-checkbox>
            </div>
          </div>
        </div>

        <div class="grid" *ngIf="periodoGracia.indicadorOtrosConceptos">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="columnasConceptos"
                     [value]="listGarantiasIdoneasPeriodoConcepto" selectionMode="single" dataKey="idConstante"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                      [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td class="table-break">{{row.codigoConceptoFacturacion}}</td>
                  <td class="table-break">{{row.conceptoFacturacion}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>


        </div>


      </p-panel>

      <p-panel header="{{ 'GARANTIASIDONEAS.LBL_INFOCOBROPERFIL' | translate}}"
               *ngIf="garantiasIdoneas && garantiasIdoneas.indicadorCobroPerfil">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="columnasCobroPerfil"
                     [value]="lisGarantiaIdoneasCobroPerfil"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.codigoPerfilRiesgo}}</td>
                  <td>{{row.porcentajeCobro}}</td>
                  <td>{{row.codigoComodinPlanCargo}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>




    </div>
  </div>
</div>






<div class="grid form-footer-buttons">
  <div class="form-group col-12">
    <div>
      <button icon="fa fa-arrow-left" label="{{'BTN_REGRESAR' | translate }}"
              type="button" (click)="regresar(false)"
              pButton></button>
    </div>
  </div>
</div>
